import { ConfigApi } from '../api/ConfigApi'

export const configStore = {
	state: {
    	config: null,
    	loading: false,
    	default: {
    		reward_amount: 10,
    		invited_amount: 10,
    		slider_ecommerce: [1991, 583, 2053],
    		modal_ecommerce: [1991, 583, 2053],
    		premium_tag: 'le piu amate'
    	}
	},

	loadConfig () {
		// don't load if alredy started loading
		if (this.state.loading) return Promise.resolve()

		// don't load if already loaded
		if (this.state.config) return Promise.resolve()

		this.state.loading = true

		var cm = new ConfigApi()
		return cm.all()

		.then(response => {
			this.state.config = {}
			response.body.data.forEach(r => {
				this.state.config[r.attributes.key] = r.attributes.value
			})

			this.state.loading = false

			return Promise.resolve(1)
		})

		.catch(response => {
			this.state.loading = false
			return response
		})
	}
}